import React from 'react'
import { withRouter, Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock'
import Skeleton from '@softwaredev_cegeka/stix-core/dist/components/Skeleton'
import UserMenu from 'src/components/Menu/UserMenu'
import isFeatureEnabled, { FEATURES } from 'src/utils/isFeatureEnabled'
import LanguageSwitchButton from 'src/components/LanguageSwitchButton'
import { isAllowed, TIMESHEETS_PERMISSION } from 'src/utils/permissions'
import { reverse } from 'src/routes/config'
import withUserData from 'src/HOCs/withUserData'
import NotificationsMfe from 'src/routes/mfes/NotificationsMfe'

import styles from './header.module.scss'

const Header = ({ userData }) => {
    return (
        <div
            aria-label="header"
            role="region"
            id="mfe-horizon-root-header-region"
            className={styles.header}
        >
            <div className={styles.topHeader}>
                <div id="page-breadcrumb-portal-mfe" />
                <div className={styles.right}>
                    <React.Suspense
                        fallback={<Skeleton width="2rem" height="2rem" />}
                    >
                        {isAllowed(userData, TIMESHEETS_PERMISSION) && (
                            <div className={styles.timesheets}>
                                <Link to={reverse('timesheets')}>
                                    <FontAwesomeIcon
                                        className={styles.timeRegistration}
                                        icon={faClock}
                                    />
                                </Link>
                            </div>
                        )}
                        {isFeatureEnabled(FEATURES.TRANSLATIONS) && (
                            <LanguageSwitchButton />
                        )}
                        <div id="page-header-bell-portal">
                            <NotificationsMfe mode={'drawer'} />
                        </div>
                        <UserMenu />
                    </React.Suspense>
                </div>
            </div>
            <div id="page-title-portal-mfe" className={styles.pageTitle} />
        </div>
    )
}

export default withUserData(withRouter(Header))
